'use client';

import { useShoppingCartContext } from '@ravago/shared/page-elements-radiance/context/shopping-cart-context';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';

import AddToShoppingCartDuplicateInfo from './add-to-shopping-cart-duplicate-info';
import AddToShoppingCartSuccess from './add-to-shopping-cart-success';
import AddToShoppingCartValidation from './add-to-shopping-cart-validation';

interface Props {
  locale: string;
}
const ShoppingCartMenu = ({ locale }: Props) => {
  const { state: shoppingCartState } = useShoppingCartContext();
  const { phone } = useBreakpoint();

  return (
    <Box width={phone ? '100%' : '400px'} direction="column" spacing="lg">
      {shoppingCartState.type === 'ADDED' && <AddToShoppingCartSuccess locale={locale} />}
      {shoppingCartState.type === 'DUPLICATE' && <AddToShoppingCartDuplicateInfo />}
      {shoppingCartState.type === 'ERROR' && shoppingCartState.validationErrors.length > 0 && <AddToShoppingCartValidation />}
    </Box>
  );
};

export default ShoppingCartMenu;
